// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m.default || m;
};

exports.components = {
  "component---src-pages-404-js": function componentSrcPages404Js() {
    return import("./../../src/pages/404.js"
    /* webpackChunkName: "component---src-pages-404-js" */
    );
  },
  "component---src-pages-index-js": function componentSrcPagesIndexJs() {
    return import("./../../src/pages/index.js"
    /* webpackChunkName: "component---src-pages-index-js" */
    );
  },
  "component---src-pages-kontakt-js": function componentSrcPagesKontaktJs() {
    return import("./../../src/pages/kontakt.js"
    /* webpackChunkName: "component---src-pages-kontakt-js" */
    );
  },
  "component---src-pages-o-nas-js": function componentSrcPagesONasJs() {
    return import("./../../src/pages/o-nas.js"
    /* webpackChunkName: "component---src-pages-o-nas-js" */
    );
  },
  "component---src-pages-produkty-alfa-nova-js": function componentSrcPagesProduktyAlfaNovaJs() {
    return import("./../../src/pages/produkty/alfa-nova.js"
    /* webpackChunkName: "component---src-pages-produkty-alfa-nova-js" */
    );
  },
  "component---src-pages-produkty-cetecoil-js": function componentSrcPagesProduktyCetecoilJs() {
    return import("./../../src/pages/produkty/cetecoil.js"
    /* webpackChunkName: "component---src-pages-produkty-cetecoil-js" */
    );
  },
  "component---src-pages-produkty-drycoolery-lu-ve-js": function componentSrcPagesProduktyDrycooleryLuVeJs() {
    return import("./../../src/pages/produkty/drycoolery-lu-ve.js"
    /* webpackChunkName: "component---src-pages-produkty-drycoolery-lu-ve-js" */
    );
  },
  "component---src-pages-produkty-js": function componentSrcPagesProduktyJs() {
    return import("./../../src/pages/produkty.js"
    /* webpackChunkName: "component---src-pages-produkty-js" */
    );
  },
  "component---src-pages-produkty-minicity-js": function componentSrcPagesProduktyMinicityJs() {
    return import("./../../src/pages/produkty/minicity.js"
    /* webpackChunkName: "component---src-pages-produkty-minicity-js" */
    );
  },
  "component---src-pages-produkty-uklady-stabilizacji-cisnienia-js": function componentSrcPagesProduktyUkladyStabilizacjiCisnieniaJs() {
    return import("./../../src/pages/produkty/uklady-stabilizacji-cisnienia.js"
    /* webpackChunkName: "component---src-pages-produkty-uklady-stabilizacji-cisnienia-js" */
    );
  },
  "component---src-pages-produkty-wymienniki-cb-js": function componentSrcPagesProduktyWymiennikiCbJs() {
    return import("./../../src/pages/produkty/wymienniki-cb.js"
    /* webpackChunkName: "component---src-pages-produkty-wymienniki-cb-js" */
    );
  },
  "component---src-pages-produkty-wymienniki-gphe-js": function componentSrcPagesProduktyWymiennikiGpheJs() {
    return import("./../../src/pages/produkty/wymienniki-gphe.js"
    /* webpackChunkName: "component---src-pages-produkty-wymienniki-gphe-js" */
    );
  },
  "component---src-pages-produkty-zawory-naval-js": function componentSrcPagesProduktyZaworyNavalJs() {
    return import("./../../src/pages/produkty/zawory-naval.js"
    /* webpackChunkName: "component---src-pages-produkty-zawory-naval-js" */
    );
  }
};